import React, { ReactNode } from "react";

import { DialogTitle, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 25px 8px"
  },

  title: {
    textTransform: "capitalize",
    padding: 0
  }
}));

interface IModalHeadProps {
  title: ReactNode;
  rightContent?: ReactNode;
}

const ModalHead: React.FC<IModalHeadProps> = props => {
  const { title, rightContent } = props;

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <DialogTitle className={classes.title}>{title}</DialogTitle>

      {rightContent}
    </div>
  );
};

export default React.memo(ModalHead);
